const WORKFLOW_SHORTCUT_ICONS = [
	{
		value: "YCSB.png",
		label: "Quy trình",
		image: require("@/assets/icons/YCSB.png"),
	},
	{
		value: "workflow-fast-forward.png",
		label: "Tiến nhanh",
		image: require("@/assets/icons/workflow-fast-forward.png"),
	},
	{
		value: "workflow-transfer.png",
		label: "Chuyển tiếp",
		image: require("@/assets/icons/workflow-transfer.png"),
	},
	{
		value: "workflow-processing.png",
		label: "Đang xử lý",
		image: require("@/assets/icons/workflow-processing.png"),
	},
	{
		value: "workflow-loading.png",
		label: "Đang tải",
		image: require("@/assets/icons/workflow-loading.png"),
	},
	{
		value: "workflow-toggle.png",
		label: "Chuyển đổi",
		image: require("@/assets/icons/workflow-toggle.png"),
	},
	{
		value: "workflow-percent.png",
		label: "Tỷ lệ",
		image: require("@/assets/icons/workflow-percent.png"),
	},
	{
		value: "workflow-grid.png",
		label: "Lưới",
		image: require("@/assets/icons/workflow-grid.png"),
	},
	{
		value: "workflow-list.png",
		label: "Danh sách",
		image: require("@/assets/icons/workflow-list.png"),
	},
	{
		value: "workflow-portal.png",
		label: "Cổng vào",
		image: require("@/assets/icons/workflow-portal.png"),
	},
];

const DEFAULT_WORKFLOW_SHORTCUT_ICON = WORKFLOW_SHORTCUT_ICONS[0].value;

const resolveWorkflowShortcutIcon = (value) => {
	const normalized = String(value || "").trim();
	return WORKFLOW_SHORTCUT_ICONS.find((icon) => icon.value === normalized) || WORKFLOW_SHORTCUT_ICONS[0];
};

const shouldUseCustomShortcutImage = (customImage, shortcutIconType) => {
	const normalizedCustomImage = String(customImage || "").trim();
	if (!normalizedCustomImage) {
		return false;
	}
	return shortcutIconType ? shortcutIconType === "custom" : true;
};

const resolveWorkflowShortcutImage = (value, customImage, shortcutIconType) => {
	return shouldUseCustomShortcutImage(customImage, shortcutIconType)
		? String(customImage || "").trim()
		: resolveWorkflowShortcutIcon(value).image;
};

export {
	DEFAULT_WORKFLOW_SHORTCUT_ICON,
	WORKFLOW_SHORTCUT_ICONS,
	resolveWorkflowShortcutIcon,
	resolveWorkflowShortcutImage,
	shouldUseCustomShortcutImage,
};
